export default __webpack_public_path__ + "static/media/main-slide-03.0501d5f1.png";